import React, { useContext, useEffect, useState } from 'react';
import { Box, Card } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { TakeoverLayout } from '_lex/_layouts/TakeoverLayout';
import { FieldForm } from '../_components';
import { enqueueSnackbar } from 'notistack';
import { translate as t } from 'hooks/useTranslations';
import { AppContext } from 'views/App/context';
import useManageFields from '../_data_sources/useManageFields';
import { CreateFieldRequest } from '../_types';
import { useQueryClient } from 'react-query';
import { ServerErrorResponse } from 'data_sources/constants';
import errorHelper from 'helpers/errorHelper';

const FieldBankNew: React.FC = () => {
  const navigate = useNavigate();
  const { hasPermission, currentOrganizationId } = useContext(AppContext);
  const { create } = useManageFields();
  const queryClient = useQueryClient();
  const [serverErrors, setServerErrors] = useState<ServerErrorResponse>();

  const handleSave = async (formData: CreateFieldRequest, status: 'Draft' | 'Active') => {
    await create(
      formData,
      (response) => {
        enqueueSnackbar(t('performanceReporting.fieldBank.create.success'), {
          variant: 'success',
          autoHideDuration: 3000,
        });
        queryClient.invalidateQueries(['fields']);
        navigate('..');
      },
      (error) => {
        setServerErrors(error);
      }
    );
  };

  // Check permissions and redirect if user doesn't have manageFieldBank permission
  useEffect(() => {
    if (!hasPermission('manageFieldBank', currentOrganizationId || '')) {
      navigate('/admin/performance-reporting');
    }
  }, [hasPermission, currentOrganizationId, navigate]);

  return (
    <TakeoverLayout
      pageTitle='Create Field'
      backUrl='..'
    >
      <Box>
        <FieldForm
          onSave={handleSave}
          onCancel={() => navigate('..')}
          serverErrors={serverErrors}
          setServerErrors={setServerErrors}
        />
      </Box>
    </TakeoverLayout>
  );
};

export default FieldBankNew;
